import { render, staticRenderFns } from "./payMoney.vue?vue&type=template&id=3c28172f&scoped=true&"
import script from "./payMoney.vue?vue&type=script&lang=js&"
export * from "./payMoney.vue?vue&type=script&lang=js&"
import style0 from "./payMoney.vue?vue&type=style&index=0&id=3c28172f&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c28172f",
  null
  
)

export default component.exports